import { DEEPLINK_TYPE_LOGIN_REDIRECT, DEEPLINK_TYPE_TINDER_U } from 'Store/user/constants';

export default {
  [DEEPLINK_TYPE_TINDER_U]: 'TinderU.preLoginMessage',
  [DEEPLINK_TYPE_LOGIN_REDIRECT]: 'HelpForm.preLoginMessage',
};
